module.exports = __webpack_public_path__ + "static/napster-bb1867d2aab20e02ef16c1bed49a5c91.png";